var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScalePlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_1895_5899_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0257222 -0.0267222 0 27.2203 25.9445)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1034.56,
    y: -1034.56,
    width: 2069.11,
    height: 2069.11
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(255, 73, 53, 1) 0deg,rgba(255, 149, 84, 1) 276.923deg,rgba(255, 73, 53, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.498047,
    y: 0.222229,
    width: 53.4444,
    height: 51.4444,
    rx: 25.7222,
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":0.28627452254295349,\"b\":0.20784313976764679,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.58431375026702881,\"b\":0.32941177487373352,\"a\":1.0},\"position\":0.76923078298568726}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":0.28627452254295349,\"b\":0.20784313976764679,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":1.0,\"g\":0.58431375026702881,\"b\":0.32941177487373352,\"a\":1.0},\"position\":0.76923078298568726}],\"transform\":{\"m00\":3.2725285206176976e-15,\"m01\":-53.444442749023438,\"m02\":53.942489624023438,\"m10\":51.444442749023438,\"m11\":3.1500636500707236e-15,\"m12\":0.222229003906250},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7141 25.922C39.7141 26.7306 39.063 27.364 38.3251 27.364H36.9361L36.9665 34.5605C36.9665 34.6818 36.9578 34.8031 36.9448 34.9243V35.6476C36.9448 36.6404 36.1678 37.4445 35.2086 37.4445H34.5141C34.4663 37.4445 34.4186 37.4445 34.3708 37.44C34.31 37.4445 34.2493 37.4445 34.1885 37.4445H31.736C30.7768 37.4445 29.9998 36.6404 29.9998 35.6476V31.6945C29.9998 30.8993 29.3791 30.257 28.6108 30.257H25.8328C25.0645 30.257 24.4438 30.8993 24.4438 31.6945V35.6476C24.4438 36.6404 23.6668 37.4445 22.7075 37.4445H20.2811C20.216 37.4445 20.1509 37.44 20.0857 37.4355C20.0337 37.44 19.9816 37.4445 19.9295 37.4445H19.235C18.2757 37.4445 17.4987 36.6404 17.4987 35.6476V30.6163C17.4987 30.5759 17.4987 30.531 17.5031 30.4906V27.364H16.1097C15.3284 27.364 14.7207 26.7351 14.7207 25.922C14.7207 25.5177 14.8509 25.1583 15.1548 24.8439L26.2842 14.8038C26.588 14.4894 26.9353 14.4445 27.2391 14.4445C27.543 14.4445 27.8902 14.5343 28.1507 14.7589L39.2367 24.8439C39.5839 25.1583 39.7576 25.5177 39.7141 25.922Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_1895_5899_clip_path"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.498047,
    y: 0.222229,
    width: 53.4444,
    height: 51.4444,
    rx: 25.7222
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalePlan);
export default __webpack_public_path__ + "static/media/scale-plan.7487e412c5e6dbf42a450fc3fdf55238.svg";
export { ForwardRef as ReactComponent };